import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=4892a8ac&scoped=true&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=4892a8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892a8ac",
  null
  
)

export default component.exports